import request from "../utils/request"

export function fetchContentAudits(params = {}) {
  return request({
    url: "/admin/content-audits",
    method: "get",
    params
  })
}

export function approveContentAudit(id) {
  return request({
    url: `/admin/content-audits/${id}/approve`,
    method: "post"
  })
}

export function rejectContentAudit(id, reason) {
  return request({
    url: `/admin/content-audits/${id}/reject`,
    method: "post",
    data: { reason }
  })
}

export function resubmitContentAudit(id) {
  return request({
    url: `/admin/content-audits/${id}/resubmit`,
    method: "post"
  })
}

export function releaseStuckContentAudits(minutes = 10) {
  return request({
    url: "/admin/content-audits/release-stuck",
    method: "post",
    data: { minutes }
  })
}
